<script setup lang="ts">
const { baseUrl } = useRuntimeConfig().public

useSchemaOrg([
  defineWebSite({
    potentialAction: [
      defineSearchAction({
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${baseUrl}/szukaj?q={search_term_string}`
        },
        'query-input': 'required name=search_term_string'
      })
    ]
  })
])
</script>

<template>
  <NuxtLoadingIndicator color="#ce1f40" />
  <Header />
  <slot />
  <Footer />
</template>
